import wrapError from "@/components/helpers/wrapError"
import wrapSuccess from "@/components/helpers/wrapSuccess"

export const apiFetchRecentUsers = (page, funcToDispatch, error) => {
  let newPage = page
  if (!page) {
    newPage = 0
  }
  $.ajax({
    type: "GET",
    url: `/api/admin/recentUsers?page=${newPage}`,
    success: wrapSuccess(funcToDispatch),
    error: wrapError(error, "apiFetchRecentUsers"),
  })
}

export const apiFetchSingleUserActions = (
  id,
  page,
  recordType,
  getByAgent,
  funcToDispatch,
  error,
) => {
  let newPage = page
  if (!page) {
    newPage = 0
  }
  $.ajax({
    type: "GET",
    url: `/api/admin/userActivity?page=${newPage}&id=${id}&recordType=${recordType}&getByAgent=${getByAgent}`,
    success: wrapSuccess(funcToDispatch),
    error: wrapError(error, "apiFetchSingleUserActions"),
  })
}

export const apiFetchUsageData = (page, filter, funcToDispatch, error) => {
  let newPage = page
  if (!page) {
    newPage = 0
  }
  $.ajax({
    type: "GET",
    url: `/api/admin/activityFeed?page=${newPage}&filter=${filter}`,
    success: wrapSuccess(funcToDispatch),
    error: wrapError(error, "apiFetchUsageData"),
  })
}

export const apiGetEngagementStats = (funcToDispatch, error) => {
  $.ajax({
    type: "GET",
    url: "/api/admin/engagementOverview",
    success: wrapSuccess(funcToDispatch),
    error: wrapError(error, "apiGetEngagementStats"),
  })
}

export const apiFetchCombinedStats = (funcToDispatch, error) => {
  $.ajax({
    type: "GET",
    url: "/api/admin/activityGraph",
    success: wrapSuccess(funcToDispatch),
    error: wrapError(error, "apiFetchCombinedStats"),
  })
}
